import { ITransactionData } from 'meta/pages/v4/transaction'

export type TransactionState = {
  transactions: Record<string, ITransactionData>
}

export const initialState: TransactionState = {
  transactions: {},
}
